export default __webpack_public_path__ + "static/media/speaker.7199cfaa.svg";